import { render, staticRenderFns } from "./ViewTreePanel.vue?vue&type=template&id=20112861&scoped=true"
import script from "./ViewTreePanel.vue?vue&type=script&lang=js"
export * from "./ViewTreePanel.vue?vue&type=script&lang=js"
import style0 from "./ViewTreePanel.vue?vue&type=style&index=0&id=20112861&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20112861",
  null
  
)

export default component.exports